import React, { useState } from 'react';

export function LoginPage({ onLogin, onForgot }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr]           = useState('');
  const [loading, setLoading]   = useState(false);
  const [forgotMode, setForgotMode] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setErr('');
    try {
      await onLogin(email.trim(), password);
    } catch (e) {
      setErr(e.message || 'Login failed');
    }
    setLoading(false);
  }

  async function handleForgot(e) {
    e.preventDefault();
    if (!email.trim()) return setErr('Enter your email first.');
    setLoading(true);
    setErr('');
    try {
      await onForgot(email.trim());
      setForgotSent(true);
    } catch (e) {
      setErr(e.message || 'Failed to send reset email');
    }
    setLoading(false);
  }

  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-title">Signed<em>Off</em></div>
        <div className="login-sub">
          {forgotMode ? 'Password Reset' : 'Apprentice Evidence Tracker'}
        </div>

        {forgotMode ? (
          forgotSent ? (
            <div className="success-msg">
              Reset link sent! Check your email inbox.
              <div style={{ marginTop: 12 }}>
                <button className="btn-sm" onClick={() => { setForgotMode(false); setForgotSent(false); }}>
                  Back to Login
                </button>
              </div>
            </div>
          ) : (
            <form onSubmit={handleForgot}>
              <div className="fgrp">
                <label className="flbl">Email</label>
                <input className="finp" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" />
              </div>
              {err && <div className="err">{err}</div>}
              <button className="btn" type="submit" disabled={loading} style={{ width: '100%', marginTop: 8 }}>
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>
              <div style={{ marginTop: 12, textAlign: 'center' }}>
                <span className="forgot-link" onClick={() => setForgotMode(false)}>Back to Login</span>
              </div>
            </form>
          )
        ) : (
          <form onSubmit={handleLogin}>
            <div className="fgrp">
              <label className="flbl">Email</label>
              <input className="finp" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" />
            </div>
            <div className="fgrp">
              <label className="flbl">Password</label>
              <input className="finp" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            <span className="forgot-link" onClick={() => setForgotMode(true)}>Forgot password?</span>
            {err && <div className="err">{err}</div>}
            <button className="btn" type="submit" disabled={loading} style={{ width: '100%', marginTop: 8 }}>
              {loading ? 'Signing In…' : 'Sign In →'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
